// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1DAkx","left":"InfoRow_left__XrxDN"};